import {
    ADD_RIGHTS,
    DELETE_ITEMS,
    DELETE_TITLE,
    DUPLICATE_TITLE,
    EDIT_TITLE,
    GET_DENIED,
    GET_DENIAL_REASONS,
    GET_EXPORT_DENIED,
    GET_IMPORT_DENIED,
    PRODUCT_OPTIONS,
    REFRESH_REQUEST,
    REQUEST_RIGHTS,
    SHOW_REQUEST_ACTIVITY,
    SHOW_REQUEST_DETAILS,
    SUBSTITUTE_TITLE
} from "@legacy/helpers/constants/sharedStatics";

export default {
    ADD_RIGHTS,
    DELETE_ITEMS,
    DELETE_TITLE,
    DUPLICATE_TITLE,
    EDIT_TITLE,
    GET_DENIED,
    GET_DENIAL_REASONS,
    GET_EXPORT_DENIED,
    GET_IMPORT_DENIED,
    PRODUCT_OPTIONS,
    REFRESH_REQUEST,
    REQUEST_RIGHTS,
    SHOW_REQUEST_ACTIVITY,
    SHOW_REQUEST_DETAILS,
    SUBSTITUTE_TITLE
};